export default __webpack_public_path__ + "static/james-bitmoji-4854ba9598c1173dafe1fb70817a8f70.png";